import React from "react";
import { Oval } from 'react-loader-spinner';

const Loader = () => {
    return (
        <div className="row no_margin">
            <div className='col-sm-2'></div>
            <div className='col-sm-8'>
                <Oval
                    height={80}
                    width={80}
                    color="#2e72a4"
                    wrapperStyle={{}}
                    wrapperClass="loaderClass"
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor="#2e72a4"
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                />
            </div>
            <div className='col-sm-2'></div>
        </div>
    )
}

export default Loader;